export const CRM_DOCUMENT_REGISTER_PATH = "/crm/documents";
